const ua = {
    accepted: ':attribute повиннен бути прийнятий.',
    alpha: 'Поле :attribute може складатись тільки з літер.',
    alpha_dash: 'Поле :attribute може складатись тільки з літер, чисел, дефісів та символів підкреслення.',
    alpha_num: 'Поле :attribute може складатись тільки з літер та чисел.',
    attributes: {},
    between: 'Значення поля :attribute повинно знаходитись між :min і :max.',
    confirmed: 'Поле :attribute не співпадає з підтвердженням.',
    email: 'Значення поля :attribute повинно бути існуючою електронною адресою.',
    def: 'Поле :attribute містить помилки.',
    digits: 'Довжина числового поля :attribute повинна бути :digits.',
    digits_between: 'Довжина цифрового поля :attribute повинна бути від :min до :max.',
    different: 'Поля :attribute і :different повинні відрізнятись.',
    in: 'Обране значення для :attribute помилкове.',
    integer: 'Значення поля :attribute повинно бути цілим числом.',
    hex: 'Значення поля :attribute повинно бути шістнадцяткового формату',
    min: {
        numeric: 'Значення поля :attribute повинно бути більшим або рівним :min.',
        string: 'Кількість символів в полі :attribute повинна бути не менше :min.',
    },
    max: {
        numeric: 'Значення поля :attribute повинно бути менше або рівне :max.',
        string: 'Кількість символів в полі :attribute не може превищувати :max.',
    },
    not_in: 'Обране значення для :attribute помилкове.',
    numeric: 'Значення поля :attribute повинно бути числом.',
    present: 'Поле :attribute повинно бути присутнім (але може бути пустим).',
    required: "Поле :attribute обов'язкове для заповнення.",
    required_if: 'Поле :attribute потрібне у випадку коли значення поля :other рівне :value.',
    same: 'Значеня поля :attribute повинно співпадати з :same.',
    size: {
        numeric: 'Значення поля :attribute повинно бути рівним :size.',
        string: 'Кількість символів в полі :attribute повинна бути рівною :size.',
    },
    url: 'Поле :attribute повинне містити валідний URL.',
    regex: 'Неправильний формат значення :attribute.',
};
export default ua;
